import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-mrfon-hold',
  templateUrl: './mrfon-hold.component.html',
  styleUrls: ['./mrfon-hold.component.scss']
})
export class MRFOnHoldComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
